import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Header,
  Form,
  Loader,
  Icon,
} from 'semantic-ui-react';
import {
  DatesRangeInput
} from 'semantic-ui-calendar-react-17';
import { reportActions } from '../../actions/report.actions';
import PropTypes from 'prop-types';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import 'moment/locale/pt-br';

const DATE_FORMAT = "DD/MM/YYYY";
const FILTER_FORMAT = "YYYY-MM-DD";

function formatDuration(seconds) {
  return moment.duration(seconds || 0, 'seconds').format('HH:mm:ss', { trim: false });
}

class SessionsReportScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      period: '',
    };
  }

  static get propTypes() {
    return {
      registers: PropTypes.any,
      loading: PropTypes.bool,
    };
  }

  componentDidMount() {
    const today = moment().format(DATE_FORMAT);
    this.setState({ period: `${today} - ${today}` }, () => this.fetchRegisters());
  }

  handlePeriodChange(period) {
    this.setState({ period }, () => this.fetchRegisters());
  }

  fetchRegisters(isExport) {
    const { dispatch } = this.props;
    const { period } = this.state;

    var [startDate, endDate] = (period || '').split(' - ');
    // An empty/cleared filter must not be sent as an empty string - the backend then falls back to its own
    // default range (last 30 days) instead of failing to bind a date.
    startDate = startDate ? moment(startDate, DATE_FORMAT).format(FILTER_FORMAT) : null;
    endDate = endDate ? moment(endDate, DATE_FORMAT).format(FILTER_FORMAT) : null;

    dispatch(reportActions.fetchSessionsReport({ startDate, endDate, export: isExport === true, exportPdf: isExport === 'pdf' }));
  }

  exportXlsx() {
    this.fetchRegisters(true);
  }

  exportPdf() {
    this.fetchRegisters('pdf');
  }

  render() {
    const { registers, loading } = this.props;
    const { period } = this.state;

    return (
      <Fragment>
        <Header>
          <h1>Sessões (Gestor)</h1>
        </Header>
        <Loader active={loading} />
        <Form>
          <Form.Group>
            <DatesRangeInput
              name="period"
              localization="pt-br"
              placeholder="Período"
              value={period}
              iconPosition="left"
              dateFormat={DATE_FORMAT}
              label='Período'
              closable={true}
              clearable={true}
              onChange={(e, data) => this.handlePeriodChange(data.value)}
            />
            <Form.Button onClick={() => this.exportXlsx()} label='&nbsp;'>
              <Icon name='file excel' /> XLSX
            </Form.Button>
            <Form.Button onClick={() => this.exportPdf()} label='&nbsp;'>
              <Icon name='file pdf' /> PDF
            </Form.Button>
          </Form.Group>
        </Form>

        {registers && registers.length > 0 &&
          <Table compact>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Usuário</Table.HeaderCell>
                <Table.HeaderCell>Tempo Ativo</Table.HeaderCell>
                <Table.HeaderCell>Tempo Bloqueado</Table.HeaderCell>
                <Table.HeaderCell>Qtd. Intervalos</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {registers.map((register) => {
                return <Table.Row key={register.UserId}>
                  <Table.Cell>{register.Name} ({register.Username})</Table.Cell>
                  <Table.Cell>{formatDuration(register.OpenSeconds)}</Table.Cell>
                  <Table.Cell>{formatDuration(register.LockedSeconds)}</Table.Cell>
                  <Table.Cell>{register.IntervalCount}</Table.Cell>
                </Table.Row>;
              })}
            </Table.Body>
          </Table>}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { report } = state;
  return {
    registers: report?.sessionsReport || null,
    loading: report?.loading
  };
}

const connectedSessionsReportScreen = connect(mapStateToProps)(SessionsReportScreen);
export { connectedSessionsReportScreen as SessionsReportScreen };
